export default {
  bind: function(el, binding) {
    const handler = e => {
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        binding.value(e)
      }
    }
    el.__vueInfiniteYScroll__ = handler
    // Add Event Listeners
    el.addEventListener('scroll', handler)
  },

  unbind: function(el) {
    // Remove Event Listeners
    el.removeEventListener('scroll', el.__vueInfiniteYScroll__)
    el.__vueInfiniteYScroll__ = null
  },
}
